import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors, YodaSpacing } from 'yoda-ui/yodaTheme';

export const chartWrapper: SxProps<Theme> = {
  width: '100%',
  height: 450,
};

export const chartTooltip: SxProps<Theme> = {
  backgroundColor: YodaColors.white,
  border: '1px solid #ccc',
  padding: YodaSpacing.xxSmall,
};

export const loaderWrapper: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
